// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index.js";

// rem
import "lib-flexible/flexible.js";

// vant
import Vant from "vant";
import "vant/lib/index.css";

// 剪裁框
import VueCropper from "vue-cropper";
Vue.use(VueCropper);

// moment
import moment from "moment";
Vue.prototype.$moment = moment;

// 移动端调试
// import VConsole from "vconsole";
// const vConsole = new VConsole();
// Vue.use(vConsole);

Vue.use(Vant);

// 图片懒加载
import { Lazyload } from "vant";
Vue.use(Lazyload);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js